import script from "./subIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./subIndex.vue?vue&type=script&setup=true&lang=js"

import "./subIndex.vue?vue&type=style&index=0&id=7d9ceb13&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d9ceb13"]])

export default __exports__